import { render } from "./WidgetFinance.vue?vue&type=template&id=3c61f394&scoped=true"
import script from "./WidgetFinance.vue?vue&type=script&lang=js"
export * from "./WidgetFinance.vue?vue&type=script&lang=js"

import "./WidgetFinance.vue?vue&type=style&index=0&id=3c61f394&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c61f394"

export default script